import styled from 'styled-components';

export const ClassificationLevelSelectContainer = styled.fieldset`
  --select-border: #777;
  --select-focus: blue;
  --select-arrow: var(--select-border);
  --font-color: #ffffff;
  --label-color: #969a9c;

  width: max-content;
  max-width: 40ch;
  border: 1px solid var(--select-border);
  border-radius: 0.25em;
  padding: 0.25em 0.5em;
  font-size: 1.25rem;
  cursor: pointer;
  line-height: 1.1;
  display: flex;
  flex-flow: column;
  align-items: flex-start;
`;

export const HighestClassificationLevelLabel = styled.label`
  color: var(--label-color);
  font-family: Aprova Nova;
  font-size: 12px;
  font-weight: 400;
  line-height: 1rem;
  text-align: left;
`;

export const HighestClassificationLevelSelect = styled.select`
  appearance: none;
  background-color: transparent;
  border: none;
  color: var(--font-color);
  padding: 0 1em 0 0;
  margin: 0;
  width: max-content;
  display: flex;
  font-family: inherit;
  font-size: 14px;
  cursor: inherit;
  line-height: inherit;

  font-family: Aprova Nova;
  font-size: 1rem;
  font-weight: 700;
`;

export const HighestClassificationLevelOption = styled.option``;
